export enum ServiceState {
  Draft = "draft",
  Completed = "completed",
  Billed = "billed",
}
